import { jsx as c } from "react/jsx-runtime";
import { forwardRef as d } from "react";
import { c as l } from "./classnames-DLUjLwnh.js";
import "isomorphic-dompurify";
import "./deprecation-Hz1LRzMC.js";
const e = d(({
  className: i,
  onCheckedChange: r,
  onChange: o,
  ...t
}, a) => /* @__PURE__ */ c(
  "input",
  {
    type: "checkbox",
    ref: a,
    onChange: (s) => {
      o == null || o(s), r == null || r(s.target.checked);
    },
    className: l(
      "h-4 w-4 rounded-[var(--ds-radius-sm)] border border-[var(--ds-color-border-default)]",
      "bg-[var(--ds-color-bg-input)] text-[var(--ds-color-bg-primary)]",
      "accent-[var(--ds-color-bg-primary)]",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ds-color-border-primary)]",
      "focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--ds-color-bg-default)]",
      "disabled:cursor-not-allowed disabled:opacity-50",
      i
    ),
    ...t
  }
));
e.displayName = "Checkbox";
export {
  e as C
};
